import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Shangchuanwenjian = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb463__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb463__a)">
            <path
              fillRule="evenodd"
              d="M38 6v18a2 2 0 1 0 4 0V6q0-1.657-1.172-2.829Q39.657 2 38 2H10Q8.343 2 7.172 3.17 6 4.343 6 6v36q0 1.657 1.172 2.828Q8.343 46 10 46h14a2 2 0 1 0 0-4H10V6h28Zm-6 12H16a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4Zm-8 8h-8a2 2 0 1 1 0-4h8a2 2 0 1 1 0 4Zm13.5 8.828 1.086 1.086a2 2 0 1 0 2.828-2.828l-1.5-1.5-3-3a2 2 0 0 0-2.828 0l-3 3-1.5 1.5a2 2 0 1 0 2.828 2.828l1.086-1.086V44a2 2 0 1 0 4 0v-9.172Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
